// Styles for AccountAccordionCardWrapper go here.
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledAccountAccordionCardWrapper = styled.div``;

export const StyledAccountAccordionContent = styled.div`
  div,
  span,
  li {
    margin: 0;
    padding: 0;
  }
  ul {
    margin-bottom: 0;
  }
`;
export const StyledAccountAccordionHeader = styled.div``;
export const StyledAccountAccordionContentWrapper = styled.div`
  .text-capitalize {
    text-transform: capitalize;
  }
  .accordion {
    &__container {
      .accordion__list {
        padding-bottom: 0;
        margin-top: 0;
      }
    }
    &__wrapper {
      &:not(:last-child) {
        border-bottom: ${toRem(1)} solid ${baseVariables.color['alert20']};
      }
      &:first-child {
        border-top: ${toRem(1)} solid ${baseVariables.color['alert20']};
      }
    }
    &__title {
      &-icon {
        font-size: ${toRem(24)};
      }
    }
    &__desc--wrapper__second {
      &.border-top {
        border-top: ${toRem(1)} dashed ${baseVariables.color['alert20']};
      }
      div.t-font-s {
        color: ${baseVariables.color['neutral40']};
        font-size: ${toRem(12)};
      }
      .accordion__title-icon {
        font-size: ${toRem(20)};
      }
    }
    &__button {
      &-icon {
        font-size: ${toRem(16)};
      }
      &-text {
        border-bottom: ${toRem(1)} solid;
      }
    }

    &__desc {
      p {
        margin: 0 !important;
      }
      ul {
        padding-left: ${toRem(20)};
      }
    }
  }
`;
export const StyledAccountContentCarouselWrapper = styled.div``;
export const StyledAccountContentWrapper = styled.div``;
